export default "__VITE_ASSET__b387f632__"